import { render, staticRenderFns } from "./NewFamily.vue?vue&type=template&id=757535a0&"
import script from "./NewFamily.vue?vue&type=script&lang=js&"
export * from "./NewFamily.vue?vue&type=script&lang=js&"
import style0 from "./NewFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports